import { getApiB2bPackages } from '/api/index';

import ValidationError from '/shared/errors/ValidationError';
import normaliseError, { toNormaliseErrorInput } from '/shared/functions/normaliseError';
import type { AppDispatch, RootState } from '/business/shared/state/store';

const getApplicationPackages = () => async (dispatch: AppDispatch, getState: () => RootState) => {
  try {
    const { applications } = getState?.() || {};

    if (applications?.fetchingPackages) {
      return applications?.packages || null;
    }

    dispatch({ type: 'GET_APPLICATION_PACKAGES_STARTED', timestamp: Date.now() });
    const { data: applicationPackages } = await getApiB2bPackages();
    dispatch({ type: 'GET_APPLICATION_PACKAGES_FULFILLED', applicationPackages });
    return applicationPackages;
  } catch (error) {
    if (error instanceof ValidationError) {
      dispatch({ type: 'GET_APPLICATION_PACKAGES_REJECTED', error });
    } else {
      dispatch({
        type: 'GET_APPLICATION_PACKAGES_REJECTED',
        error: normaliseError(toNormaliseErrorInput(error), 'GET_APPLICATION_PACKAGES'),
      });
    }
    throw error;
  }
};

export default getApplicationPackages;
